// Splits a leaderboard into the top-3 (rendered as bars) and the rest (a
// table). Ports defenderV2's processLeaderboard: if the viewer isn't in the
// top 3 but appears further down, their row is moved to the front of the
// table so they can always see themselves without scrolling.
export const splitLeaderboard = (rows, myPlayerId) => {
  const normalized = (rows ?? []).map((row) => ({ ...row, isMe: row.playerId === myPlayerId }))
  const top3 = normalized.slice(0, 3)
  const others = normalized.slice(3)

  const meIndex = others.findIndex((row) => row.isMe)
  if (meIndex !== -1 && !top3.some((row) => row.isMe)) {
    const [me] = others.splice(meIndex, 1)
    others.unshift(me)
  }

  return { top3, others }
}
